
import Alert from '@/components/elements/Alert.vue'
import LabelRequire from '@/components/elements/LabelRequire.vue'
import LabelOptional from '@/components/elements/LabelOptional.vue'

export default {
  name: 'FormFieldset',

  components: {
    Alert,
    LabelRequire,
    LabelOptional
  },

  props: {
    label: {
      type: String,
      default: ''
    },
    patternLabel: String,
    req: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    description: String,
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: String
  }
}
